/* STAY. — scripts du thème */
(function () {
  'use strict';

  /* Menu téléphone */
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('.burger');
    if (!burger) return;
    var open = document.body.classList.toggle('menu-open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* Flèches des rails de produits */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-rail-arrow]');
    if (!arrow) return;
    var rail = document.getElementById(arrow.getAttribute('aria-controls'));
    if (!rail) return;
    var card = rail.querySelector('.card');
    var step = card ? card.getBoundingClientRect().width + 20 : 400;
    rail.scrollBy({ left: arrow.dataset.railArrow === 'next' ? step : -step, behavior: 'smooth' });
  });

  /* Sélecteur de variantes (page produit) */
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + parts[1];
    var noDecimals = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return (format || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/, parts[0] + '.' + parts[1])
      .replace(/[,.]00(?=\D|$)/, '');
  }

  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form[data-product-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var moneyFormat = root.dataset.moneyFormat;

    function selectedOptions() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function update() {
      var opts = selectedOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
      });
      root.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var label = fs.querySelector('[data-selected-value]');
        var checked = fs.querySelector('input:checked');
        if (label && checked) label.textContent = checked.value;
      });
      var buttons = root.querySelectorAll('[data-add-button]');
      if (!variant) {
        buttons.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = 'Indisponible'; });
        return;
      }
      if (idInput) idInput.value = variant.id;
      root.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = formatMoney(variant.price, moneyFormat); });
      root.querySelectorAll('[data-compare-price]').forEach(function (el) {
        el.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price, moneyFormat) : '';
      });
      buttons.forEach(function (b) {
        b.disabled = !variant.available;
        var label = b.querySelector('span');
        label.textContent = variant.available ? b.dataset.labelAdd + ' · ' + formatMoney(variant.price, moneyFormat) : b.dataset.labelSoldout;
      });
      if (variant.featured_media) {
        var target = root.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        var gallery = root.querySelector('.product__gallery');
        if (target && gallery) {
          if (window.matchMedia('(max-width: 900px)').matches) {
            gallery.scrollTo({ left: target.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
          } else {
            gallery.prepend(target);
          }
        }
      }
      if (window.history.replaceState && root.dataset.updateUrl === 'true') {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      /* Barre les tailles épuisées pour la couleur choisie */
      root.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var index = parseInt(fs.dataset.optionIndex, 10);
        fs.querySelectorAll('input').forEach(function (input) {
          var test = opts.slice(); test[index] = input.value;
          var match = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === test[i]; }); });
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update();
    });
    update();

    /* Bundle : ajoute le produit choisi et les produits du lot */
    root.querySelectorAll('[data-bundle]').forEach(function (bundle) {
      var btn = bundle.querySelector('button');
      btn.addEventListener('click', function () {
        var items = [];
        if (idInput && idInput.value) items.push({ id: parseInt(idInput.value, 10), quantity: 1 });
        bundle.querySelectorAll('[data-bundle-variant]').forEach(function (el) {
          items.push({ id: parseInt(el.dataset.bundleVariant, 10), quantity: 1 });
        });
        btn.disabled = true;
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error();
          window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        }).catch(function () {
          btn.disabled = false;
          var err = bundle.querySelector('.product-form__error');
          if (err) err.hidden = false;
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-root]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-product-root]').forEach(initProduct);
  });

  /* Filtres de collection : envoi automatique */
  document.addEventListener('change', function (e) {
    var f = e.target.closest('form[data-auto-submit]');
    if (f) f.submit();
  });

  /* Lien « Guide des tailles » : ouvre l'onglet */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-open-details]');
    if (!a) return;
    var d = document.querySelector(a.getAttribute('href'));
    if (!d) return;
    e.preventDefault();
    d.open = true;
    d.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* Recommandations automatiques « Tu aimeras aussi » */
  function loadRecommendations(scope) {
    scope.querySelectorAll('[data-recommendations]').forEach(function (el) {
      if (el.children.length) return;
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        else { var sec = el.closest('.section'); if (sec) sec.hidden = true; }
      }).catch(function () {});
    });
  }
  loadRecommendations(document);
  document.addEventListener('shopify:section:load', function (e) { loadRecommendations(e.target); });

  /* Panier : quantité modifiée = mise à jour */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cart-qty]')) e.target.form.submit();
  });

  /* Ajout rapide depuis la page collection */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-size]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('[data-quick-card]');
    var data = card.querySelector('[data-quick-variants]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var color = card.querySelector('input[type=radio]:checked');
    var size = btn.dataset.quickSize;
    var v = variants.find(function (x) { return x.options.indexOf(size) > -1 && (!color || x.options.indexOf(color.value) > -1) && x.available; });
    if (!v) { btn.disabled = true; return; }
    btn.disabled = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error(); window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; })
      .catch(function () { btn.disabled = false; });
  });
})();
